import { Select } from "antd";
const { Option } = Select;

export { Select, Option };
